import * as React from 'react';
import { TFunction } from 'i18next';
import {
  CheckSquareIcon,
  CoinIcon,
  DesktopIcon,
  HandshakeIcon,
  ShoppingCartIcon,
  WrenchIcon,
} from '@fronton/icons-react';
import { LinkWithGAClickButton } from 'common/components';
import { creditLinkStyle } from './benefits-section-styles';

export type BenefitSectionDataStructure = {
  icon: React.ReactNode;
} & (
    | { text: string; textFormatter?: never }
    | { text?: never; textFormatter: (t: TFunction, isRuRegion: boolean) => React.ReactNode }
  );

export const BENEFITS_SECTION_DATA: BenefitSectionDataStructure[] = [
  {
    icon: <DesktopIcon strokeWidth={0.8} type="outline" size="xxl" color="text-primary" />,
    text: 'benefits-section.benefit-first',
  },
  {
    icon: <WrenchIcon strokeWidth={0.8} type="outline" size="xxl" color="text-primary" />,
    text: 'benefits-section.benefit-second',
  },
  {
    icon: <CoinIcon strokeWidth={0.8} type="outline" size="xxl" color="text-primary" />,
    textFormatter: (t: TFunction, isRuRegion: boolean) => (
      isRuRegion ? (
        <>
          <LinkWithGAClickButton
            elementBlock="landingVannuyuKomnatu"
            elementName="Преимущества проектирования в Леруа Мерлен"
            elementText="Кредит или рассрочка"
            className={creditLinkStyle}
            href="/service/kredit/"
            rel="noreferrer"
            target="_blank"
            title="Товары в кредит">
            Кредит или рассрочка
          </LinkWithGAClickButton>{' '}
          на&nbsp;ваш&nbsp;выбор
        </>
      ) : t('benefits-section.benefit-third-text')
    ),
  },
  {
    icon: <ShoppingCartIcon strokeWidth={0.8} type="outline" size="xxl" color="text-primary" />,
    text: 'benefits-section.benefit-fourth',
  },
  {
    icon: <HandshakeIcon strokeWidth={0.8} type="outline" size="xxl" color="text-primary" />,
    text: 'benefits-section.benefit-fifth',
  },
  {
    icon: <CheckSquareIcon strokeWidth={0.8} type="outline" size="xxl" color="text-primary" />,
    text: 'benefits-section.benefit-sixth',
  },
];
